import $ from "jquery";

import "../styles/main.scss";

// $(document).ready(ready);
